import api from '@/utils/api';

/**
 * Get all users roles
 * @returns {Promise}
 */
const getUserRolesSelect = () => api.get('conf/user-roles-select');

export default getUserRolesSelect;
